module.exports = __webpack_public_path__ + "img/icon-recommend.23f05ff.webp";